import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { UpdateCredentials } from '../../types/user/auth'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useUpdatePassword() {
  const { t } = useTranslation(['auth', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { putter } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const updatePassword = async (updateCredentials: UpdateCredentials) => {
    setLoading(true)
    try {
      await putter(
        `${CONFIG.BOUNCE_API}/api/v1/account/password`,
        updateCredentials,
        'application/json'
      )
      setSuccess(t('auth:password.password-successfully-updated'))
      setError(null)
    } catch (error) {
      console.log(error)
      if (error instanceof ApiError) {
        const translatedMessage = getErrorMessage(error.data)
        setError(translatedMessage)
      } else setError(t('exceptions:unknown'))
    } finally {
      setLoading(false)
    }
  }

  return { updatePassword, loading, error, success, resetState }
}
